// extracted by mini-css-extract-plugin
export default {"container":"chart_container_tvCov","content":"chart_content_dOKzu","details":"chart_details_h9ezY","title":"chart_title_xJrdj"};